import { Link } from "react-router-dom";
import LiveMap, { useLiveMap } from "./LiveMap";
import { MapPinned } from "lucide-react";

export default function DashboardMap() {
  const data = useLiveMap(60000);
  const active = (data?.cleaners || []).filter((c) => c.source !== "off");
  return (
    <div className="mt-12" data-testid="dashboard-map">
      <div className="flex items-center justify-between mb-4">
        <div className="label-caps text-muted-foreground flex items-center gap-2">
          <MapPinned className="w-4 h-4 text-brand" /> Cleaners right now · {active.length} on a job
        </div>
        <Link to="/map" className="text-sm text-brand hover:underline" data-testid="dashboard-map-open">Open Live Map</Link>
      </div>
      <LiveMap data={data} height={300} testid="dashboard-live-map" />
    </div>
  );
}
